/**
 * Template: Index
 * -----------------------------------------------------------------------------
 * Scripts to execute on the index page.
 *
 */
import {load} from '@shopify/theme-sections';
import NostoSlider from '../components/nosto-slider';
import Alpine from "alpinejs";

window.Alpine = Alpine;

Alpine.start();

import '../sections/image-slider';
import '../sections/featured-collection';

document.addEventListener('DOMContentLoaded', () => {
    load('*');
    NostoSlider().init();
});
